// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.research-page {
    padding-top: 80px;
    min-height: 100vh;
    background-color: #f8f9fa;
}

.research-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 40px 20px 60px;
}

.research-title {
    text-align: center;
    font-size: 2.2rem;
    color: #2c3e50;
    margin-bottom: 16px;
    font-weight: 700;
}

.research-intro {
    text-align: center;
    color: #666;
    font-size: 1.1rem;
    max-width: 700px;
    margin: 0 auto 40px;
    line-height: 1.6;
}

.projects-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
    gap: 24px;
}

.project-card {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.project-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

.project-image {
    width: 100%;
    height: 200px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.project-content {
    padding: 24px;
    display: flex;
    flex-direction: column;
    flex: 1 1;
}

.project-title {
    font-size: 1.2rem;
    color: #2c3e50;
    margin-bottom: 12px;
    font-weight: 600;
}

.project-description {
    font-size: 0.92rem;
    color: #555;
    line-height: 1.65;
    flex: 1 1;
    margin-bottom: 16px;
}

.project-link {
    color: #3498db;
    font-weight: 600;
    text-decoration: none;
    font-size: 0.95rem;
    align-self: flex-start;
    transition: color 0.2s ease;
}

.project-link:hover {
    color: #2980b9;
    text-decoration: underline;
}

@media (max-width: 768px) {
    .research-container {
        padding: 24px 16px 40px;
    }

    .research-title {
        font-size: 1.6rem;
    }

    .research-intro {
        font-size: 1rem;
    }

    .projects-grid {
        grid-template-columns: 1fr;
    }

    .project-image {
        height: 180px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ResearchPage/ResearchPage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,aAAa;IACb,sBAAsB;IACtB,qDAAqD;AACzD;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,SAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".research-page {\n    padding-top: 80px;\n    min-height: 100vh;\n    background-color: #f8f9fa;\n}\n\n.research-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 40px 20px 60px;\n}\n\n.research-title {\n    text-align: center;\n    font-size: 2.2rem;\n    color: #2c3e50;\n    margin-bottom: 16px;\n    font-weight: 700;\n}\n\n.research-intro {\n    text-align: center;\n    color: #666;\n    font-size: 1.1rem;\n    max-width: 700px;\n    margin: 0 auto 40px;\n    line-height: 1.6;\n}\n\n.projects-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\n    gap: 24px;\n}\n\n.project-card {\n    background: #fff;\n    border-radius: 10px;\n    overflow: hidden;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n    display: flex;\n    flex-direction: column;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.project-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\n}\n\n.project-image {\n    width: 100%;\n    height: 200px;\n    background-size: cover;\n    background-position: center;\n    background-repeat: no-repeat;\n}\n\n.project-content {\n    padding: 24px;\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n}\n\n.project-title {\n    font-size: 1.2rem;\n    color: #2c3e50;\n    margin-bottom: 12px;\n    font-weight: 600;\n}\n\n.project-description {\n    font-size: 0.92rem;\n    color: #555;\n    line-height: 1.65;\n    flex: 1;\n    margin-bottom: 16px;\n}\n\n.project-link {\n    color: #3498db;\n    font-weight: 600;\n    text-decoration: none;\n    font-size: 0.95rem;\n    align-self: flex-start;\n    transition: color 0.2s ease;\n}\n\n.project-link:hover {\n    color: #2980b9;\n    text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n    .research-container {\n        padding: 24px 16px 40px;\n    }\n\n    .research-title {\n        font-size: 1.6rem;\n    }\n\n    .research-intro {\n        font-size: 1rem;\n    }\n\n    .projects-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .project-image {\n        height: 180px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
